function Stepper({ stepNumber, numSteps }) {
  return (
    <div className="cost-comparison-tool__container">
      <div id="cct-progress-bar" className="progress-indicator">
        <div className="progress-indicator__container">
          <div className="progress-indicator__title">
            Step <span>{stepNumber}</span> of <span>{numSteps}</span>
          </div>
          <div className="progress-indicator__bar">
            <span style={{ width: `calc((100% / ${numSteps}) * ${stepNumber})` }}></span>
          </div>
        </div>
      </div>
    </div>
  );
}
